<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.WarmReminder')"
    width="500px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :show-close="false"
    top="5vh"
    custom-class="details-view booking-result-dialog"
  >
    <div class="main-content">
      <span style="font-size:14px;padding-bottom:5px">{{ $t('CargoMsg.Cargo_YdBookingResultTip') }}</span>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :show-side-bar="false"
          :row-data="this.ydBookingResult.diffJobList || []"
          min-height="470px"
          @gridReady="onGridReady"
        />
      </div>
    </div>
    <div slot="footer" class="footer">
      <div>
        <el-button type="primary" no="notReplace" @click="onNotReplace">{{ $t('CargoMsg.Cargo_NotReplace') }}</el-button>
        <el-button type="primary" no="confirmReplace" @click="onConfirmReplace">{{ $t('CargoMsg.Cargo_ConfirmReplace') }}</el-button>
      </div>
      <div>
        <el-button no="cancel" @click="onCancel">{{ $t('CargoMsg.Cargo_Ignore') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { updateByYdBookingResults } from '@/api/seaExport/edi'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'YdBookingResultDialog',
  components: { CargoAgGrid },
  props: {
    visible: { type: Boolean, required: true, default: () => false },
    jobUuid: { type: String, required: true },
    job: { type: Object, required: true },
    ydBookingResult: { type: Object, required: true }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          resizable: true,
          filter: true
        },
        pagination: false
      },
      gridParams: {},
      columnDefs: [
        { headerName: '', checkboxSelection: true, width: 50, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_FieldName'), field: 'fieldName', width: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_CargoValue'), field: 'cargoValue', width: 140, minWidth: 140,
          cellRenderer: (params) => {
            if (params.data.fieldCode) {
              if (['destinationPortCode', 'dischargingPortCode', 'dispatchingPlace', 'loadingPortCode'].includes(params.data.fieldCode)) {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              } else {
                return params.value
              }
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_YdValue'), field: 'ydValue', width: 140, minWidth: 140,
          cellRenderer: (params) => {
            return params.data.mappingValue || params.value
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('close')
    },
    // 确认覆盖
    onConfirmReplace() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToReplace'))
        return
      }
      const fieldList = []
      let noMappingValues = ''
      for (const item of rows) {
        if (item.noMappingValue) {
          switch (item.fieldCode) {
            case 'destinationPortCode':
              noMappingValues += (StrUtils.isEmpty(noMappingValues) ? '' : '、') + this.$t('CargoMsg.Cargo_PlaceOfDelivery')
              break
            case 'dischargingPortCode':
              noMappingValues += (StrUtils.isEmpty(noMappingValues) ? '' : '、') + this.$t('CargoMsg.Cargo_PortOfDischarge')
              break
            case 'dispatchingPlace':
              noMappingValues += (StrUtils.isEmpty(noMappingValues) ? '' : '、') + this.$t('SeaExport.DocDispatchingPlace')
              break
            case 'loadingPortCode':
              noMappingValues += (StrUtils.isEmpty(noMappingValues) ? '' : '、') + this.$t('CargoMsg.Cargo_PortOfLoading')
              break
          }
        }
        fieldList.push(item.fieldCode)
      }
      if (noMappingValues) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoMappingValuesTip', [noMappingValues]))
        return
      }
      this.toUpdateBookingResults(true, false, fieldList)
    },
    // 都不覆盖
    onNotReplace() {
      this.toUpdateBookingResults(false, true)
    },
    toUpdateBookingResults(confirmReplace, notReplace, fieldList) {
      const bookingResult = {}
      bookingResult.jobUuid = this.jobUuid
      bookingResult.uuid = this.ydBookingResult.uuid
      bookingResult.confirmReplace = confirmReplace
      bookingResult.notReplace = notReplace
      bookingResult.replaceFieldList = fieldList || []
      this.loading = getLoading()
      updateByYdBookingResults(bookingResult).then(res => {
        if (res.data) {
          this.onCancel()
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
          if (confirmReplace) {
            this.$emit('refreshJob')
          }
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.selectAll()
    }
  }
}
</script>

<style lang="scss">
.booking-result-dialog {
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
